module.exports = __webpack_public_path__ + "assets/img/btn-info-a492f39c.png";